import Paragraph from "~/componentsDS/Typography/Paragraph";
import Rating from "~/componentsND/Rating";

const ReviewsRatingOld = () => {
    return (
        <div className="flex md:items-center gap-3 mt-2 md:mt-0 tracking-[1.28px] text-primary300 leading-[20px] uppercase pt-1">
            <Rating rating={5} />
            <Paragraph size="md" sizes={{ md: "sm", lg: "md" }} weight="500" className="mr-[2px]">
                4.9/5
            </Paragraph>
            <Paragraph size="md" sizes={{ md: "sm", lg: "md" }} weight="500">
                5,695 Reviews
            </Paragraph>
        </div>
    );
};

export default ReviewsRatingOld;